module.exports = __webpack_public_path__ + "img/quest_validation_info.6c44c209.svg";